import React from "react";
import { VideoTestimonials } from "./VideoTestimonials";
import "./css/video-testimonials.scss";
import { ThemeProvider } from "@kaena1/mm-ui-components";
import { theme } from "@kaena1/mm-ui-theme-v3";
import "@kaena1/mm-ui-theme-v3/styles.css";
import "@kaena1/mm-ui-components/components.css";
import { createRoot } from "react-dom/client";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <VideoTestimonials />
    </ThemeProvider>
  );
};

const videoTestimonialsRoot = document.getElementById('videoTestimonialsRoot');

if (videoTestimonialsRoot) {
  const root = createRoot(videoTestimonialsRoot);
  root.render(<App />);
}